import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router';
import {
    LoadingSpinnerPresets,
    PresetLoadingSpinner,
} from 'dg-web-shared/common/components/material-ui/PresetLoadingSpinner';
import { useParkingaboAuthedPathGeneration } from '../routes/RouteUtils';

import { CustomerTenantState } from '../shared/ParkingaboModels';
import { useCustomerContext } from './CustomerProvider.tsx';

export function ProductsAccessChecker() {
    const { user } = useCustomerContext();
    const navigate = useNavigate();
    const generateAuthedParkingaboPath = useParkingaboAuthedPathGeneration();
    const [routeChecked, setRouteChecked] = useState(false);

    useEffect(() => {
        switch (user.customerState) {
            case CustomerTenantState.ACTIVE:
                break;
            case CustomerTenantState.LOCKED:
                navigate(generateAuthedParkingaboPath('locked-account'));
                break;
            case CustomerTenantState.ARCHIVED:
                throw new Error('Archived user tried to access products');
        }
        const timeoutId = setTimeout(() => setRouteChecked(true), 0);
        return () => clearTimeout(timeoutId);
    }, [generateAuthedParkingaboPath, navigate, user.customerState]);

    if (!routeChecked) {
        return (
            <PresetLoadingSpinner
                preset={LoadingSpinnerPresets.FillAllSpaceAndCenter}
            />
        );
    } else {
        return <Outlet />;
    }
}
